import classNames from 'classnames/bind';
import styles from './ConnectLayout.module.scss';
import Graphic from '~/components/Graphic';
import { Outlet } from 'react-router-dom';

const cx = classNames.bind(styles);

function ConnectLayout() {
    return (
        <div className={cx('wrapper')}>
            <div className={cx('graphic-container')}>
                <Graphic />
            </div>
            <div className={cx('connect-container')}>
                <Outlet />
            </div>
        </div>
    );
}

export default ConnectLayout;
